import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import {formatarData, formataDataHora} from '@/util/formatacoes';

export const createImpressaoRemessa = function (remessa, pedidos_estado, user) {

  let data_hora = formataDataHora(new Date());

  let estados = [];

  pedidos_estado.forEach((estado) => {

    let estado_body = [];
    estado_body[0] = [
      { text: 'Número', style: 'small', bold: true, alignment: 'center', fillColor: '#CCCCCC' },
      { text: 'Cliente', style: 'small', bold: true, fillColor: '#CCCCCC' },
      { text: 'Cidade', style: 'small', bold: true, fillColor: '#CCCCCC' },
    ];

    estado.pedidos.forEach((pedido_estado) => {
      estado_body.push(
        [
          {
            text: pedido_estado.id.toString(),
            style: 'medium',
            alignment: 'center',
            bold: true,
            border: [true, true, false, false]
          },
          {
            text: pedido_estado.cliente_nome,
            style: 'medium',
            bold: true,
            border: [false, true, false, false]
          },
          {
            text: pedido_estado.endereco.cidade.nome,
            style: 'medium',
            bold: true,
            border: [false, true, true, false]
          },
        ],

        [
          {
            columns: [
              {
                text: pedido_estado.endereco.rua,
                style: 'small',
              },
              {
                text: 'Número: ' + pedido_estado.endereco.numero,
                style: 'small',
              },
              {
                text: 'Bairro: ' + pedido_estado.endereco.bairro,
                style: 'small',
              },
            ],
            colSpan: 3,
            border: [true, false, true, false]
          },
          {},
          {}
        ],

        [
          {
            columns: [
              {
                text: 'CEP: ' + pedido_estado.endereco.cep,
                style: 'small',
              },
              {
                text: 'Telefone: ' + pedido_estado.endereco.telefone,
                style: 'small',
              },
              {
                text: 'Celular: ' + pedido_estado.endereco.celular,
                style: 'small',
              },
            ],
            colSpan: 3,
            border: [true, false, true, true]
          },
          {},
          {}
        ],
      );
    });

    estados.push(
      {
        text: estado.estado_nome,
        bold: true,
        style: 'medium',
        italics: true
      },
      {
        style: 'tableExample',
        table: {
          widths: [50, '*', '*'],
          body: estado_body,
        },
      }
    );
  });

  let schema = {};

  function processar() {
    schema = {
      info: {
        title: 'Remessa ' + remessa.id.toString() + ' - NaModa.com.vc',
        author: 'NaModaComVc',
        subject: 'Listagem de remessa',
      },

      pageMargins: [40, 100, 40, 60],

      header: {
        margin: [40, 20, 40, 100],
        columns: [
          {
            style: 'tableExample',
            table: {
              widths: ['*'],
              body: [
                [
                  {
                    image: 'logo',
                    width: 100,
                    alignment: 'center'
                  },
                ],
              ],
            },
          },
          {},
          {
            style: 'tableExample',
            table: {
              widths: ['*'],
              heights: [23, 10, 10],
              body: [
                [
                  {text: 'Remessas', alignment: 'center', margin: [0, 5, 0, 0], bold: true},
                ],
                [
                  {text: user.nome, alignment: 'center'},
                ],
                [
                  {text: 'Listagem de Remessas', alignment: 'center'},
                ]
              ],
            },
          },
        ],
      },

      content: [
        {
          margin: [0, 0, 0, 5],
          table: {
            widths: ['*'],
            body: [
              [
                { text: '', border:[false, true, false, false] },
              ]
            ]
          },
        },

        {
          text: 'REMESSA',
          style: 'subheader',
          margin: [0, 0, 0, 15]
        },
        {
          columns: [
            {
              text: [
                'Número: ',
                {text: remessa.id, bold: true}
              ]
            },
            {
              text: [
                'Motorista: ',
                {text: remessa.motorista, bold: true},
              ],
              alignment: 'right'
            },
          ]
        },
        {
          columns: [
            {
              text: [
                'Placa: ',
                {text: remessa.placa, bold: true}
              ]
            },
            {
              text: [
                'Saída: ',
                {text: formatarData(remessa.data_saida), bold: true, style: 'small'},
                ' - ',
                {text: remessa.hora_saida, bold: true, style: 'small'},
              ]
            },
            {
              text: [
                'Chegada: ',
                {text: formatarData(remessa.data_chegada), bold: true, style: 'small'},
                ' - ',
                {text: remessa.hora_chegada, bold: true, style: 'small'},
              ],
              alignment: 'right'
            },
          ]
        },

        {
          margin: [0, 15, 0, 15],
          table: {
            widths: ['*'],
            body: [
              [
                { text: '', border:[false, true, false, false] },
              ]
            ]
          },
        },

        {
          text: 'PEDIDOS',
          style: 'subheader',
        },
        estados,
      ],

      footer: function(currentPage, pageCount) {
        return [
          {
            margin: [40, 0, 40, 0],
            table: {
              widths: ['*'],
              body: [
                [
                  { text: '', border:[false, true, false, false] },
                ]
              ]
            },
          },

          {
            columns: [
              {text: 'NaModa.com.vc', margin: [40, 0, 0, 0], alignment: 'left', style: 'small', bold: true},
              [
                {text: data_hora, margin: [0, 0, 40, 0], alignment: 'right', style: 'small'},
                {text: 'Página ' + currentPage.toString() + ' de ' + pageCount, margin: [0, 0, 40, 0], alignment: 'right', style: 'small'}
              ]
            ],
          },
        ]
      },

      styles: {
        header: {
          fontSize: 18,
          bold: true
        },
        subheader: {
          fontSize: 15,
          bold: true
        },
        medium: {
          fontSize: 12
        },
        small: {
          fontSize: 10
        },
        tableExample: {
          margin: [0, 5, 0, 15]
        },
      },

      images: {
        logo: 'data:image/jpeg;base64,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'
      }
    }
  }

  function imprimirPDF() {
    pdfMake.createPdf(schema).open();
  }

  function baixarPDF() {
    pdfMake.createPdf(schema).download();
  }

  return {
    processar,
    imprimirPDF,
    baixarPDF
  };

}